import http from './http'

export default {
  verify: password => http.post('/v2/action-gate/verify', { password }, { silent: true })
}



// WEBPACK FOOTER //
// ./src/services/api/actionGate.js